import { useRef, useState, useEffect } from 'react';
import './ScrollMask.scss';

export function useScrollMask(deps = []) {
    const ref = useRef(null);
    const [maskClass, setMaskClass] = useState('');

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const update = () => {
            const { scrollTop, scrollHeight, clientHeight } = el;
            if (scrollHeight <= clientHeight + 1) {
                setMaskClass('');
                return;
            }
            const atTop = scrollTop <= 1;
            const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
            if (atTop) {
                setMaskClass(atBottom ? '' : 'scroll-mask-bottom');
                return;
            }
            setMaskClass(atBottom ? 'scroll-mask-top' : 'scroll-mask-both');
        };

        update();
        el.addEventListener('scroll', update, { passive: true });
        const ro = new ResizeObserver(update);
        ro.observe(el);
        return () => {
            el.removeEventListener('scroll', update);
            ro.disconnect();
        };
    }, deps);

    return [ref, maskClass];
}
